<template>
  <div class="detail-item flex justify-between items-center py-1">
    <span class="font-medium text-gray-700">{{ label }}</span>
    <span class="text-gray-900">{{ value }}</span>
  </div>
</template>
<script setup lang="ts">
import { defineProps } from 'vue';
const props = defineProps<{ label: string; value: string | number | undefined }>();
</script>
<style scoped>
.detail-item {
  border-bottom: 1px solid #f3f4f6;
}
</style>
